import { z } from "zod";

export const importBatchTypeSchema = z.enum(["PATIENTS", "APPOINTMENTS"]);
export type ImportBatchType = z.infer<typeof importBatchTypeSchema>;

export type ImportBatchSummary = {
  id: string;
  type: ImportBatchType;
  fileName: string | null;
  totalRecords: number;
  createdCount: number;
  updatedCount: number;
  skippedCount: number;
  errorCount: number;
  createdAt: Date;
  /** Qtd real de registros ainda vinculados ao batch (pode ter sido deletada manualmente). */
  liveCount: number;
};
